import React from "react";

const Clearfix = () => {
  return <div style={{ clear: "both" }} />;
};

export default Clearfix;
